import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { get, set, first } from 'global/lib/lodash';

export const useEdit = (props) => {
  const view = useSelector((s) => s.view);
  const dispatch = useDispatch();

  const editOn = get(view, 'edit.on', false);

  const toggleEdit = () => {
    const _view = { ...view };

    set(_view, 'edit.on', !editOn);

    dispatch({ type: 'SET_VIEW', view: _view });
  };

  return {
    editOn,
    toggleEdit,
  };
};
